<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_15",
      next: "P_17",
      topic: "",
      progress: false,
      show: false
    };
  },
  created: function() {
    window.setInterval(() => {
      this.show = true;
    }, 300);
  }
};
</script>

<style lang="stylus">
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}

.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider(style='margin-top:-58px;')
              | TALLER ¿QUÉ ES CRÉDITO?
            v-card-text.titulo36Book
              |  ¡Quiero saber qué es y para qué sirve un crédito!
            .video-responsive
              iframe.py-4(width="420" height="315" src="https://player.vimeo.com/video/353671341" frameborder="0" allowfullscreen)
            v-card-text.parrafoDestacado18.mx-0.px-0
              | Sabemos que hay diferentes tipos de créditos, pero también es importante comparar diferentes aspectos para asegurarnos de elegir el crédito que se acople mejor a nuestras necesidades. ¡Revisa los siguiente conceptos!
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextChapter(next)")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

